import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play",
  "use": "icon-play-usage",
  "viewBox": "0 0 18 21",
  "content": "<symbol viewBox=\"0 0 18 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play\">\n<path d=\"M16.4978 13.15L5.17505 19.6545C3.12732 20.859 0.597778 19.4136 0.597778 17.0045V3.99541C0.597778 1.70677 3.12732 0.261315 5.17505 1.34541L16.4978 7.84995C18.4251 9.0545 18.4251 11.9454 16.4978 13.15Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol